import { isAxiosError } from "axios";

type ServerError = { message?: unknown; errors?: { message?: unknown }[] };

/**
 * The server's message for a failed request (Nest puts it in `message`), or a fallback. For a
 * request the server refused as invalid, the first problem it names, which says what to fix.
 */
export const apiErrorMessage = (error: unknown, fallback = "Something went wrong"): string => {
  if (isAxiosError(error)) {
    const data = error.response?.data as ServerError | undefined;
    const first = data?.errors?.find((issue) => typeof issue.message === "string")?.message;
    if (data?.message === "Validation failed" && typeof first === "string") return first;
    const message = data?.message;
    if (typeof message === "string") return message;
    if (Array.isArray(message)) return message.join(", ");
    if (!error.response) return "Can't reach the server — check your connection";
  }
  return fallback;
};

export const apiErrorStatus = (error: unknown): number | undefined =>
  isAxiosError(error) ? error.response?.status : undefined;
